<template>
  <el-table-column
    prop="id_card_number"
    label="Szig. szám"
    sortable="custom"
    min-width="150"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.id_card_number || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'id_card_number',
  };
</script>
